import BidCheckmarkIcon from '../../../../../elements/BidCheckmarkIcon/BidCheckmarkIcon'
import Label from '@components/ItemPage/Details/Important/Label'

export default function BidWinningLabel({ children = 'Winning' }) {
  return (
    <Label>
      <BidCheckmarkIcon />
      <span className="block pl-1">{children}</span>
    </Label>
  )
}
